/**
 * 模块
 * @author fulh
 * @update 2015-01-21 20:31:16
 */
$.module('MM.fixedbar.history', function () {
  var MAIN = null,
    TMPL = null,
    ACTIONS = {
      followList: 'user/following_list/{access_token}',
    };

  function _show() {
    TMPL = MM.fixedbar.tmpl;
    MAIN = MM.fixedbar.main;
    MAIN.initDialog(
      $.template(TMPL.history, MM.user.getUserInfo()),
      true,
      'history',
    );
    _renderList();
  }

  function _renderList() {
    MM.ui.base.manuRender(
      $('#j_fixedbar_history .follow-star'),
      TMPL.history_list,
      MM.util.record.getList(),
    );
    MAIN.showDialog('history');
  }
  return {
    show: _show,
  };
});
